import { Box, Flex } from '@chakra-ui/react';
import { FilePayload } from '@worknet/models';

import { useFileAttachments } from '~/shared/utils/useFileAttachments';

import Markdown from './Markdown';
import MessageAttachment from './MessageAttachment';

type Props = {
  message: string;
  isSameUser?: boolean;
  attachments?: FilePayload[];
  attachmentIds?: string[];
};

export default function UserMessage({
  message,
  isSameUser,
  attachments: directAttachments,
  attachmentIds,
}: Props) {
  const { attachments: fetchedAttachments, loading } = useFileAttachments(
    directAttachments ? undefined : attachmentIds
  );

  const attachments = directAttachments || fetchedAttachments;
  return (
    <Box minW={0}>
      <Box
        alignItems="center"
        border="1px solid transparent"
        fontSize="chatText"
        fontWeight={300}
        lineHeight={1.357}
        borderRadius="8px"
        padding="10px 16px"
        backgroundColor={isSameUser ? 'main' : '#F2F2F2'}
        color={isSameUser ? 'tertiary' : 'black'}
      >
        {attachments && attachments.length > 0 && (
          <Flex mb={2} gap={2} mt={2} flexWrap="wrap">
            {attachments.map((file) => (
              <MessageAttachment key={file.id} file={file} inUserMessage={isSameUser} />
            ))}
          </Flex>
        )}

        <Markdown content={message} />
      </Box>

      {loading && attachmentIds?.length && (
        <Box mt={2} fontSize="xs" color="gray.500">
          Loading attachments...
        </Box>
      )}
    </Box>
  );
}
